// extracted by mini-css-extract-plugin
module.exports = {"navItem":"_2EpiRP"};